import React from 'react';
import { Flex } from '../Flex';
import { Icon } from '../Icon';
import { Text } from '../Text';
import { Pill } from '../Pill';
export function BannerProduct({ icon, label, statusText }) {
    return (React.createElement(Flex, { alignItems: "center", gap: "space-50" },
        icon && React.createElement(Icon, { size: "extra-small", src: icon, color: "secondary" }),
        React.createElement(Text, { variant: "caption-medium", color: "secondary", textOverflow: { extraSmall: true } }, label),
        React.createElement(Pill, { variant: "informative", size: "small", hidden: !statusText }, statusText)));
}
BannerProduct.displayName = 'Banner.Product';
//# sourceMappingURL=BannerProduct.js.map